export var HTMLMediaElementEvents;
(function (HTMLMediaElementEvents) {
    HTMLMediaElementEvents["LoadedData"] = "loadeddata";
    HTMLMediaElementEvents["CanPlayThrough"] = "canplaythrough";
    HTMLMediaElementEvents["LeavePictureInPicture"] = "leavepictureinpicture";
})(HTMLMediaElementEvents || (HTMLMediaElementEvents = {}));
export var HTMLMediaElementReadyState;
(function (HTMLMediaElementReadyState) {
    HTMLMediaElementReadyState[HTMLMediaElementReadyState["HaveNothing"] = 0] = "HaveNothing";
    HTMLMediaElementReadyState[HTMLMediaElementReadyState["HaveMetadata"] = 1] = "HaveMetadata";
    HTMLMediaElementReadyState[HTMLMediaElementReadyState["HaveCurrentData"] = 2] = "HaveCurrentData";
    HTMLMediaElementReadyState[HTMLMediaElementReadyState["HaveFutureData"] = 3] = "HaveFutureData";
    HTMLMediaElementReadyState[HTMLMediaElementReadyState["HaveEnoughData"] = 4] = "HaveEnoughData";
})(HTMLMediaElementReadyState || (HTMLMediaElementReadyState = {}));
